import React from "react";
import { motion } from "framer-motion";
import VerticalSlideFeatures from "../components/servicesPage/features";

const services = [
  {
    title: "Packers & Movers",
    desc: "Professional and affordable packing, loading, and shifting services ensuring safe relocation for homes and businesses.",
    icon: "📦",
  },
  {
    title: "Car Transportation",
    desc: "Get your vehicle transported securely across cities with verified logistics partners specialized in vehicle handling.",
    icon: "🚗",
  },
  {
    title: "Cargo & Freight Services",
    desc: "Reliable freight forwarding and cargo movement solutions for both domestic and commercial logistics needs.",
    icon: "🚚",
  },
  {
    title: "Warehousing Solutions",
    desc: "Secure and scalable warehouse storage options for goods and business inventory with real-time tracking.",
    icon: "🏢",
  },
  {
    title: "Bike Transport",
    desc: "Quick and affordable two-wheeler transport with packaging, insurance, and real-time updates.",
    icon: "🏍️",
  },
  {
    title: "Intercity Moving",
    desc: "Connect with trusted movers for fast and affordable intercity relocation of homes, offices, or goods.",
    icon: "🛣️",
  },
];

const Services = () => {
  return (
    <div className="bg-[#F5F7FA] min-h-screen py-12 px-4 md:px-10 text-[#1F1F1F]">
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-4xl md:text-5xl font-bold text-center text-[#004182] mb-4"
      >
        Our Services
      </motion.h1>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
        className="text-center max-w-2xl mx-auto text-lg text-gray-700 mb-12"
      >
        Tiranga Express offers a full suite of logistics and relocation services tailored to your needs — from moving homes to business cargo.
      </motion.p>

      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3 max-w-7xl mx-auto">
        {services.map((service, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: idx * 0.1, duration: 0.6 }}
            viewport={{ once: true }}
            className="bg-white rounded-xl p-6 shadow-md border-t-4 border-[#F3A712] hover:border-[#E03A3E] transition-all duration-300"
          >
            <div className="text-4xl mb-4">{service.icon}</div>
            <h3 className="text-2xl font-semibold text-[#004182] mb-2">
              {service.title}
            </h3>
            <p className="text-gray-700 mb-4">{service.desc}</p>
            <button className="bg-[#004182] hover:bg-[#E03A3E] text-white px-4 py-2 rounded transition">
              Get Quote
            </button>
          </motion.div>
        ))}
      </div>
      <VerticalSlideFeatures />
    </div>
  );
};

export default Services;
